import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ldapServerType'
})
export class ServerTypePipe implements PipeTransform {

  transform(value: any, ...args: unknown[]): unknown {
    let serverTypeIcon = '';

    if (value && value.toLowerCase() === 'ldap') {
      serverTypeIcon = '<i class="fa fa-group" title="LDAP Server"></i>';
    } else if (value && value.toLowerCase() === 'azure') {
      serverTypeIcon = '<i class="fa fa-windows" title="Azure Active Directory"></i>';
    } else if (value && value.toLowerCase() === 'ump') {
      serverTypeIcon = '<img src="assets/images/general/ump_icon.svg" title="UMP" width="35">';
    }

    return `<div class="center-content">${serverTypeIcon}</div>`;
  }
}
